import { render, staticRenderFns } from "./AwardBuyModalDefaultContent.vue?vue&type=template&id=7aedef5e&scoped=true"
import script from "./AwardBuyModalDefaultContent.vue?vue&type=script&lang=js"
export * from "./AwardBuyModalDefaultContent.vue?vue&type=script&lang=js"
import style0 from "./AwardBuyModalDefaultContent.vue?vue&type=style&index=0&id=7aedef5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aedef5e",
  null
  
)

export default component.exports